"use strict";
/**
 * BOS Brand Palette Colors
 *
 * This palette contains colors for BOS and E-COM
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.bosColor = void 0;
var bosColor;
(function (bosColor) {
    // Primary
    bosColor["darkBlue"] = "#30306f";
    bosColor["turquoise"] = "#5cd6d2";
    // Secondary
    bosColor["ultramarine"] = "#202146";
    bosColor["blue"] = "#4ba9c9";
    bosColor["oker"] = "#ffcb66";
    bosColor["komorebi"] = "#62c785";
    bosColor["poppy"] = "#eb5b4f";
    bosColor["concrete"] = "#4a4e54";
    // Secondary 60%
    bosColor["turquoise60"] = "#9de7e4";
    bosColor["blue60"] = "#93cbdf";
    bosColor["oker60"] = "#ffe0a4";
    bosColor["komorebi60"] = "#a1ddb6";
    bosColor["poppy60"] = "#f39d95";
    // Secondary 20%
    bosColor["turquoise20"] = "#e2f8f7";
    bosColor["blue20"] = "#e9f5f9";
    bosColor["oker20"] = "#fff5e0";
    bosColor["komorebi20"] = "#e0f4e7";
    bosColor["poppy20"] = "#f9ceca";
    // Monotone
    bosColor["black"] = "#191919";
    bosColor["white"] = "#fcfcfc";
    bosColor["darkGrey"] = "#5d5d5d";
    bosColor["neutralPlus"] = "#b1b1b1";
    bosColor["neutralGrey"] = "#e3e3e3";
    bosColor["lightGrey"] = "#f3f3f3";
    // Expression
    bosColor["positive"] = "#1bb061";
    bosColor["neutral"] = "#ffcb66";
    bosColor["destructive"] = "#db6456";
})(bosColor = exports.bosColor || (exports.bosColor = {}));
exports.default = {
    bosColor: bosColor,
};
//# sourceMappingURL=bosno.js.map